export default {"src":"/_next/static/media/canyoning.78a9c685.svg","height":685,"width":685,"blurWidth":0,"blurHeight":0};